module.exports = __webpack_public_path__ + "img/MJSS.2fc27649.png";